import React, { Component } from "react";
import InputPassword from "components/Common/InputPassword";

import Button from "components/Common/Button";
import Notification from "components/Common/Notification";
import PropTypes from "prop-types";
import { Record } from "immutable";
import { connect } from "react-redux";
import { getResource } from "selectors/resources";
import { Client } from "resourceModels";

export class BaseLoginForm extends Component {
  formInput = React.createRef();

  /**
   * focus on Input form
   */
  componentDidMount() {
    if (this.formInput) {
      this.formInput.current.focus();
    }
  }

  handleKeyDown = (event) => {
    const { checkUser } = this.props;

    if (event.key === "Enter") {
      checkUser();
    }
  }

  handleKeyPress = (event) => {
    const { togglePasswordReset } = this.props;

    if (event.key === "Enter") {
      togglePasswordReset();
    }
  }


  handleCloseNotification = () => {
    const { resetNotificationError } = this.props;
    resetNotificationError();
  }

  /**
 * @returns {HTMLElement}
 */
  render() {
    const {
      /** @type Client */
      client,
      changeEmail, changePassword, checkUser, login, session, togglePasswordReset, password
    } = this.props;

    const isButtonDisabled = login.email.length && password.length;
    const shouldShowError = login.showError;
    let notificationDescription = "That didn’t work. Please check your credentials and try again.";

    if (login.passwordExpired) {
      notificationDescription = "Your session has expired. Please login again.";
    }

    const sessionTimeoutBannerText = "For security purposes we now log you out after being inactive for 24 hours. Please log in again.";

    return (
      <div className="g-form__block Login__block">
        <div className="Login__page-header">
          <h1>Login</h1>
          <p>Continue to {client.name} bot</p>
          <Notification
            description={sessionTimeoutBannerText}
            notificationType="info"
            customClassName="Login__notification"
          />
          {shouldShowError && (
            <Notification
              description={notificationDescription}
              notificationType="error"
              customClassName="Login__notification"
              onClose={this.handleCloseNotification}
            />
          )}
        </div>

        <label className="g-input__label" htmlFor="Login__email">
          Email
        </label>
        <input
          className="Login__input g-view g-input"
          value={login.email}
          type="email"
          placeholder="lovelace@ada.support"
          ref={this.formInput}
          id="Login__email"
          onChange={changeEmail}
          onKeyDown={this.handleKeyDown}
        />
        <label className="g-input__label" htmlFor="Login__password">
          Password
        </label>
        <InputPassword
          value={password}
          onPasswordChange={changePassword}
          toggleDisabled={false}
          inputId="Login__password"
          onKeyDown={checkUser}
          autoComplete="current-password"
        />
        <div className="Login__actions-container">
          <div
            className="Login__actions-container__forgot"
            onClick={togglePasswordReset}
            role="link"
            tabIndex={0}
            onKeyPress={this.handleKeyPress}
          >
            Forgot Your Password?
          </div>
          <Button
            onClick={checkUser}
            customClassName="Login__actions-container__button"
            title="Log In"
            text="Log In"
            icon="SignIn"
            isLoading={session.isAuthenticating}
            disabled={!isButtonDisabled || session.isAuthenticating}
            disabledStyleFlat
          />
          <div
            className="Login__actions-container__terms"
          >
            <p className="g-form__block__description Login__actions-container__terms__description">
              By continuing, you agree to Ada&#39;s <a href="https://www.ada.support/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://www.ada.support/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

BaseLoginForm.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  checkUser: PropTypes.func.isRequired,
  login: PropTypes.instanceOf(Record).isRequired,
  password: PropTypes.string.isRequired,
  session: PropTypes.instanceOf(Record).isRequired,
  togglePasswordReset: PropTypes.func.isRequired,
  resetNotificationError: PropTypes.func.isRequired,

  client: PropTypes.instanceOf(Client).isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = connect(mapStateToProps)(BaseLoginForm);

Connector.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  checkUser: PropTypes.func.isRequired,
  login: PropTypes.instanceOf(Record).isRequired,
  session: PropTypes.instanceOf(Record).isRequired,
  togglePasswordReset: PropTypes.func.isRequired,
  resetNotificationError: PropTypes.func.isRequired
};

export default Connector;
